import { render, staticRenderFns } from "./LgameFooter.vue?vue&type=template&id=ff3fb2ea&scoped=true&"
import script from "./LgameFooter.vue?vue&type=script&lang=js&"
export * from "./LgameFooter.vue?vue&type=script&lang=js&"
import style0 from "./LgameFooter.vue?vue&type=style&index=0&id=ff3fb2ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff3fb2ea",
  null
  
)

export default component.exports